export const DEFAULT_GROUP_COLOR = '#000000';

export const selectedTypeMapping = {
  virtual: {
    value: 'virtual',
    label: 'Virtual'
  },
  physical: {
    value: 'physical',
    label: 'Physical'
  },
  collection: {
    value: 'collection',
    label: 'Collection'
  }
};
